

















































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, ReflectCondition } from "../../modules/teacher/CbtScheduleEdit"
import { BModal, BCarousel } from 'bootstrap-vue';

export interface Data {
  sheet_group_key: string
  sheets: Sheet[]
  reflectCondition: ReflectCondition
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    'date-time-picker' : VueCtkDateTimePicker,
  },
  setup(prop, context){

    const modalRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_group_key: "",
      sheets: [],
      reflectCondition: new ReflectCondition(),
      errors: new Array<string>(),
    });

    const showModal = () => {
      modalRef.value.show();
    }

    /******************************
     * 一括入力 反映ボタン押下
     ******************************/

    const refrect = () => {
      state.sheets.forEach(x => {
        if(!x.is_exists_test_started_examinees){
          x.test_start_datetime_at = state.reflectCondition.test_start_datetime_at;
          x.limit_time = state.reflectCondition.limit_time;
          x.grace_time = state.reflectCondition.grace_time;
        }
      });
    };

    /******************************
     * 更新API
     ******************************/

    const update = async () => {
      
      state.errors = [];
      for(let i = 0; i < state.sheets.length; i++){
        const sheet = state.sheets[i];
        
        // 編集不可の行はチェック不要
        if(!sheet.test_start_datetime_at){
          continue;
        }

        // テスト開始日時チェック
        if(!moment(sheet.test_start_datetime_at).isValid()){
          state.errors.push(`(${i + 1}行目) テスト開始日時の入力値が不正です。`);
        }

        // 制限時間チェック
        if(sheet.limit_time == "" || sheet.limit_time == null){
          state.errors.push(`(${i + 1}行目) 制限時間が入力されていません。`);
        }else if(isNaN(Number(sheet.limit_time))){
          state.errors.push(`(${i + 1}行目) 制限時間に数字以外が入力されています。`);
        }else if(Number(sheet.limit_time) <= 0){
          state.errors.push(`(${i + 1}行目) 制限時間は1分以上を入力してください。`);
        }

        // 猶予時間チェック
        if(sheet.grace_time == "" && sheet.grace_time != null){
          state.errors.push(`(${i + 1}行目) 猶予時間が入力されていません。`);
        }else if(isNaN(Number(sheet.grace_time))){
          state.errors.push(`(${i + 1}行目) 猶予時間に数字以外が入力されています。`);
        }else if(parseInt(sheet.grace_time) < 0){
          state.errors.push(`(${i + 1}行目) 猶予時間は0分以上を入力してください。`);
        }
      }

      // エラーありの場合は処理終了
      if(state.errors.length > 0){
        return;
      }

      // 更新対象のsheet取得 画面表示時点の内容から変更あるsheetのみ抽出
      const sheets = new Array<Sheet>();
      state.sheets.forEach(x => {
        if(x.test_start_datetime_at != x.test_start_datetime_at_cache || x.grace_time != x.grace_time_cache || x.limit_time != x.limit_time_cache){
          sheets.push(x);
        }
      });

      // 変更件数０件の場合は処理終了
      if(sheets.length == 0){
        alert("変更されたクラスはありません。");
        return;
      }

      if(!window.confirm("テスト日程を登録します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/cbt_schedule_edit/update/${state.sheet_group_key}`, {sheets: sheets}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }


    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;

      await http.get(`/api/teacher/cbt_schedule_edit/?sheet_group_key=${state.sheet_group_key}`).then(response => {
        
        response.data.sheets.forEach((sheet: any) => {
          state.sheets.push(new Sheet(sheet));
        });
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });

      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      refrect,
      update,
      showModal,
      modalRef
    };
  }
});
